import $ from 'jquery';

export default {
  name: 'ShareSpec',
  props: {
    specLink: {
      required: true
    }
  },
  data() {
    return {
      emailFields: 1,
      success: false,
      error: false
    };
  },
  mounted() {
    $(document).on('hidden.bs.modal', '.share-spec', () =>
      this.resetFormState()
    );
  },
  computed: {
    url() {
      if (typeof this.specLink === 'string') return this.specLink;
      return this.specLink.url;
    }
  },
  methods: {
    addEmail() {
      this.emailFields++;
    },
    resetFormState() {
      this.emailFields = 1;
      this.error = false;
      this.success = false;
    },
    sendSpec() {
      const emails = $('input[name="emails[]"]')
        .map(function() {
          return $(this).val();
        })
        .get();

      $.ajax({
        method: 'POST',
        url: '/sloan-share-spec/send',
        data: `emails=${emails}&specLink=${this.url}`
      })
        .done(() => {
          this.error = false;
          this.success = true;
        })
        .catch(() => {
          this.error = true;
          this.success = false;
        });
    }
  }
};
